export const contest = {
    qjy: 'Buôn bán',
    grbm: 'Đăng ký cá nhân',
    qdl: 'Đi đến đăng nhập',
    bsyjs: 'Cuộc thi đã kết thúc',
    bmks: 'Bắt đầu đăng ký',
    bsjs: 'Cuộc thi đã kết thúc',
    djs: 'Khoảng cách tới Cuộc thi Giao dịch ảo {v1} (Đếm ngược)',
    days: 'Ngày',
    hours: 'Giờ',
    minutes: 'Phút',
    seconds: 'Giây',
    ljyq: 'Mời ngay',
    tdbm: 'Đăng ký nhóm',
    qzc: 'Đi đến đăng ký',
    qrsfgrbm: 'Xác nhận có muốn tham gia đăng ký cá nhân không?',
    qxbm: 'Hủy đăng ký',
    qrbm: 'Xác nhận đăng ký',
    gxnbmcg: 'Chúc mừng bạn, đăng ký thành công, bạn sẽ nhận được 10W USDT ảo',
    xzjs: 'Chọn vai trò bạn muốn trở thành',
    cwty: 'Trở thành thành viên nhóm',
    cwtz: 'Trở thành nhóm trưởng',
    cjtd: 'Tạo nhóm',
    jtgz: 'Quy tắc tạo nhóm:',
    jtgz1: '1. Nếu nhóm có ít hơn 5 người trong vòng 24 giờ, nhóm sẽ tự động giải tán và tự động tham gia Cuộc thi Giao dịch ảo cá nhân',
    jtgz2: '2. Trong thời gian chờ đợi để tạo nhóm, bạn không thể đăng ký tham gia Cuộc thi Giao dịch ảo cá nhân',
    jtgz3: '3. Sau khi tạo nhóm thành công, bạn sẽ không thể tham gia nhóm khác và Cuộc thi Giao dịch ảo cá nhân',
    tdmc: 'Tên nhóm:',
    tdjj: 'Giới thiệu nhóm:',
    ljjt: 'Tạo nhóm ngay',
    tdmcbt: 'Vui lòng nhập tên nhóm',
    tdjzbt: 'Vui lòng nhập giới thiệu nhóm',
    cjzdcg: 'Tạo nhóm thành công!',
    xzjrtd: 'Chọn nhóm bạn muốn tham gia ngay',
    sstdmc: 'Tìm kiếm tên nhóm',
    dqzdsl: 'Số lượng nhóm hiện tại: {v1}, hãy chọn nhóm bạn muốn tham gia',
    ddtdrs: 'Số người hiện tại trong nhóm: {v1} người',
    tdrs: 'Số người trong nhóm:',
    tzmc: 'Tên trưởng nhóm:',
    jrtd: 'Tham gia nhóm',
    jrzdcg: 'Tham gia nhóm thành công!',
    grfxlj: 'Liên kết chia sẻ cá nhân:',
    grtjm: 'Mã giới thiệu cá nhân:',
    tdfxlj: 'Liên kết chia sẻ nhóm:',
    tdtjm: 'Mã giới thiệu nhóm:',
    tdtzm: 'Tên trưởng nhóm:',
    bctp: 'Lưu ảnh',
    total: 'Tổng cộng {v1} mục',
    dd: 'Đến trang',
    qd: 'Xác định',
    cyyj: 'Tham gia có giải thưởng',
    jcdnn: 'Hồ bơi giải thưởng USDT đang chờ bạn!',
    jzcj: 'Quyên góp lợi nhuận, tham gia rút thăm trúng thưởng',
    dqjc: 'Hồ bơi giải thưởng hiện tại:',
    qjz: 'Đến quyên góp',
    jzsm: 'Hướng dẫn quyên góp',
    kjz: 'Hiện bạn có thể quyên góp {v1} USDT cho Quỹ từ thiện, bạn có chắc muốn quyên góp không?',
    qxjz: 'Hủy quyên góp',
    qrjz: 'Xác nhận quyên góp',
    jzcg: 'Chúc mừng bạn, quyên góp thành công!',
    mnpjyds: 'Cuộc thi Giao dịch ảo',
    bm: 'Đăng ký:',
    bs: 'Cuộc thi:',
    hyspjyds: 'Cuộc thi giao dịch hợp đồng',
    xhspjyds: 'Cuộc thi giao dịch hàng hóa',
    bmz: 'Đang mở đăng ký',
    jqqd: 'Hãy chờ đợi',
    bsz: 'Đang diễn ra cuộc thi',
    yjs: 'Đã kết thúc',
    myptts: 'Cuộc thi đội giả lập',
    mypzmxs: 'Cuộc thi ngôi sao hàng tuần',
    mypgrs: 'Cuộc thi cá nhân giả lập',
    hyjyds: 'Cuộc thi giao dịch hợp đồng',
    xhjyds: 'Cuộc thi giao dịch hàng hóa',
    my: 'Của tôi',
    pm: 'Xếp hạng',
    dync: 'Bí danh đội',
    dm: 'Tên đội',
    zdrs: 'Số người trong đội',
    nc: 'Bí danh',
    ljzjy: 'Tổng giao dịch tích lũy',
    ljzjye: 'Tổng giá trị giao dịch',
    ljzyll: 'Tỷ lệ lợi nhuận tích lũy',
    zyll: 'Tỷ lệ lợi nhuận tổng cộng',
    zdjl: 'Phần thưởng đội',
    mypbsjl: 'Tham gia có thưởng',
    myphycs: 'Tham gia cuộc thi hợp đồng giả lập',
    myhyj: 'Đăng ký thành công nhận 100,000U vàng giả lập ngay',
    ljbm: 'Tham gia ngay',
    tzjl: 'Mở đội có thưởng',
    ztcg: '5 người thành đội, tối đa 200 người',
    bwzbhl: 'Thành công làm đội trưởng nhận thêm 100,000U+',
    yqjl: 'Mời có thưởng',
    yqhycybs: 'Mời làm đội trưởng, tối đa nhận 100,000U',
    hzhyj: 'Mời làm thành viên, tối đa nhận 50,000U',
    mnttbssm: 'Giải thích quy tắc cuộc thi đội giả lập lớn',
    // 团队赛规则
    csxq: 'Chi tiết tham gia:',
    csxq1: '1. Ngày bắt đầu đăng ký hoạt động - Người dùng có thể mở đội bất kỳ khi nào trong thời gian từ ngày bắt đầu đến ngày kết thúc cuộc thi (sau khi xác minh danh tính), cuộc thi đội hợp đồng cần đủ số người ≥ 5 người; ≤ 200 người; Nếu trong vòng 24 giờ sau khi mở đội không đủ 5 người, đội chiến sẽ tự động giải tán và các thành viên của đội sẽ tự động tham gia khu vực cá nhân.',
    csxq2: '2. Người dùng chỉ có thể chọn một đội và tham gia, không thể tham gia lại, không thể tham gia cùng một lúc cả cuộc thi đội và cuộc thi cá nhân, người dùng tham gia đội không thể tự nguyện rời khỏi đội.',
    ssgz: 'Quy tắc sự kiện:',
    ssgz1: '1. Phúc lợi của đội trưởng: 1) Mỗi lần mời một thành viên tham gia, đội có thể nhận được 1000 USDT vàng giả lập, giới hạn thưởng mời là 100000 USDT;',
    ssgz1_2: '2) Đội trưởng mời thành công hơn 20 người bạn tham gia và giao dịch có thể nhận bộ đồ siêu đẹp của Coin King.',
    ssgz2: '2. Phúc lợi của thành viên đội: Mỗi lần mời một người bạn tham gia, thành viên đội có thể nhận được 500 USDT vàng giả lập, giới hạn thưởng mời là 50000 USDT',
    ssgz3: '3. Sau khi cuộc thi đội kết thúc, nền tảng sẽ sử dụng tổng số giao dịch thực tế của đội làm tiêu chí cuối cùng để xếp hạng cuối cùng',
    ssgz4: '4. Tổng giá trị giao dịch của khu vực cuộc thi đội giả lập hàng ngày sẽ được cập nhật vào mỗi ngày lúc 0 giờ',
    ssgz5: '5. Để đảm bảo công bằng cho kết quả cuộc thi, vui lòng không làm giả mạo giao dịch bằng ý đồ xấu, nếu phát hiện hành vi làm giả mạo dữ liệu giao dịch, đội ngũ dịch vụ khách hàng của biking sẽ can thiệp. Tổng giá trị giao dịch của khu vực cuộc thi đội giả lập hàng ngày sẽ được cập nhật vào mỗi ngày lúc 0 giờ',
    ssgz6: '6. Để biết thêm chi tiết về quy tắc hoạt động, vui lòng liên hệ đội ngũ dịch vụ khách hàng biking.',
    jlfp: 'Phân phối thưởng:',
    jlfp1: '1. Phân phối tiền thưởng USDT: (Khi phân phối tiền thưởng, tiền mô phỏng và tiền mặt luôn được phân phối theo tỷ lệ 9:1)',
    jlfp1_1: '1) Tỷ lệ phân phối nội bộ đội:',
    jlfp1_2: 'Đội trưởng có thể nhận tiền thưởng = Tổng giá trị giao dịch hợp đồng tích lũy cá nhân của đội trưởng / Tổng giá trị giao dịch cuộc thi đội giả lập biking * 5000000 USDT',
    jlfp1_3: '+ Tổng hiệu suất khác của đội / Tổng giá trị giao dịch cuộc thi đội giả lập biking * 20% * 5000000 USDT.',
    jlfp1_4: 'Thành viên đội có thể nhận tiền thưởng = Tổng giá trị giao dịch hợp đồng tích lũy hiện tại của người dùng / Tổng giá trị giao dịch cuộc thi đội giả lập biking * 80% * 5000000 USDT.',
    jlfp1_5: '2) Các đội thi đấu xuất sắc trong suốt cuộc thi có thể thưởng thức lợi nhuận cộng đồng! Tỷ lệ cộng đồng tăng cường hiệu suất được xác định dựa trên số người và tổng giá trị giao dịch của đội, mỗi lần gấp đôi số lượng đội / tổng giá trị giao dịch sẽ nhận được 50% cộng đồng sức mạnh',
    myptdjyze: 'Tổng giá trị giao dịch của khu vực cuộc thi đội giả lập biking',
    myptdphb: 'Bảng xếp hạng đội giả lập cuộc thi biking',
    tdsl: 'Số lượng đội hiện tại: {v1}, chọn đội bạn muốn tham gia',
    tznc: 'Bí danh đội trưởng:',
    tdjs: 'Giới thiệu đội:',
    // Quy tắc ngôi sao hàng tuần
    mypzmxgzsm: 'Giải thích quy tắc cuộc thi ngôi sao hàng tuần đội giả lập',
    zmxphb: 'Bảng xếp hạng đội ngôi sao hàng tuần (Chỉ lấy ba người đầu tiên)',
    zmxtdphb: 'Bảng xếp hạng đội ngôi sao hàng tuần',
    bdxq: 'Chi tiết bảng xếp hạng:',
    bdxq1: '1. Khi thành công xây dựng đội và bắt đầu giao dịch, mặc định bạn tham gia xếp hạng đội ngôi sao hàng tuần',
    zmxgz: '1. Hệ thống sẽ xếp hạng các đội tham gia cuộc thi theo tổng giá trị giao dịch của đội trong mỗi tuần tự nhiên và công bố "Bảng xếp hạng đội ngôi sao hàng tuần", ba đội đầu tiên trong bảng xếp hạng sẽ chia sẻ tổng cộng 2000000 USDT giải thưởng mô phỏng hợp đồng.',
    zmxgz1: '2. Danh sách đội hình ngôi sao hàng tuần được cập nhật vào lúc 14h thứ 4 hàng tuần',
    bddym: 'Đội đầu tiên nhận 1000000 USDT vàng giả lập;',
    dbdem: 'Người đứng thứ hai nhận 600000 USDT vàng giả lập;',
    bddsm: 'Người đứng thứ ba nhận 400000 USDT vàng giả lập;',
    tdnbfpgz: 'Quy tắc phân phối nội bộ đội:',
    tzx: 'Đội trưởng hưởng: 20%;',
    nbyjpm: 'Người chơi hàng đầu trong hiệu suất nội bộ (trừ đội trưởng): Chia sẻ 40%',
    syty: 'Người chơi còn lại: 40%',
    // 个人赛规则
    mypgrsgzsm: 'Giải thích quy tắc cuộc thi cá nhân giả lập',
    mypgrphb: 'Bảng xếp hạng cá nhân cuộc thi giả lập lớn',
    bsxz: 'Lưu ý cuộc thi:',
    bsxz1: '1. Mỗi người mới đăng ký tham gia cuộc thi đều nhận được 100,000 USDT vàng giả lập',
    bsxz2: '2. Người chơi cũ đăng ký tham gia có thể nhận được 50,000 USDT vàng giả lập',
    bsxz3: '2. Trong thời gian tham gia cuộc thi, người chơi có thể tiếp tục nhận tiền trải nghiệm bằng cách mời bạn bè tham gia:',
    bsxz4: '1) Mỗi lần người dùng mời bạn bè tham gia, họ sẽ nhận được 2.000 USDT quỹ dùng thử mô phỏng；',
    // bsxz5: '2) Mỗi lần mời một người chơi cũ tham gia cuộc thi, bạn có thể nhận 2,000 USDT trải nghiệm;',
    bsxz6: '2) Thưởng mời có thể lên đến 50,000 USDT',
    bsxz7: '3. Khu vực thi chỉ dành cho người dùng đã xác minh danh tính trên sàn giao dịch Coin King.',
    bsxz8: '4. Sau khi cuộc thi kết thúc, hệ thống sẽ xếp hạng cá nhân theo tổng lợi nhuận của người chơi.',
    grgzsm1: '1. Tổng giải thưởng: 2,000,000 USDT + 30 sản phẩm xung quanh tuyệt vời',
    grgzsm2: '2. Chi tiết phân phối:',
    grgzsm3: 'Người đầu tiên: 800,000 USDT + 5 sản phẩm xung quanh tuyệt vời',
    grgzsm4: 'Người thứ hai: 500,000 USDT + 5 sản phẩm xung quanh tuyệt vời',
    grgzsm5: 'Người thứ ba: 200,000 USDT + 3 sản phẩm xung quanh tuyệt vời',
    grgzsm6: 'Người thứ tư đến thứ hai mươi: Chia sẻ 500,000 USDT + 17 sản phẩm xung quanh tuyệt vời',
    hyjybs: 'Cuộc thi giao dịch hợp đồng',
    hyjybsgzsm: 'Giải thích quy tắc cuộc thi giao dịch hợp đồng',
    hyspgrphb: 'Bảng xếp hạng cá nhân cuộc thi lớn về hợp đồng',
    // Quy tắc cuộc thi hợp đồng
    csxz: 'Lưu ý tham gia:',
    hybsgz1: '1. Đăng ký tham gia cuộc thi giao dịch hợp đồng sẽ nhận được 100 USDT vàng giả lập (việc sử dụng vàng giả lập sẽ tuân theo các quy định chi tiết của nền tảng), lợi nhuận từ giao dịch với vàng giả lập này sẽ không được tính vào tỷ lệ lợi nhuận tổng cộng trong thời gian tham gia.',
    hybsgz2: '2. Người dùng có thể mời bạn bè tham gia cuộc thi giao dịch hợp đồng, mỗi lần mời một người bạn tham gia thành công, bạn sẽ nhận được thưởng vàng giả lập 20 USDT, giới hạn thưởng mời là 100 USDT.',
    hybsgz3: '3. Khu vực thi chỉ dành cho người dùng đã xác minh danh tính trên sàn giao dịch Coin King.',
    hybsgz4: '4. Sau khi cuộc thi kết thúc, hệ thống sẽ xếp hạng cuộc thi dựa trên tỷ lệ lợi nhuận tổng cộng của người chơi trong thời gian cuộc thi.',
    jcfp: 'Phân phối giải thưởng:',
    jcfp1: 'Tổng giải thưởng: 2,000,000 USDT + 30 sản phẩm xung quanh tuyệt vời',
    fpgz: 'Quy tắc phân phối:',
    fpgzs: '(Khi phân phối giải thưởng, vàng giả lập và tiền mặt luôn được phân phối theo tỷ lệ 9:1)',
    fpgz1: 'Người đầu tiên: 800,000 USDT + 5 sản phẩm xung quanh tuyệt vời',
    fpgz2: 'Người thứ hai: 500,000 USDT + 5 sản phẩm xung quanh tuyệt vời',
    fpgz3: 'Người thứ ba: 200,000 USD + 3 sản phẩm xung quanh tuyệt vời',
    fpgz4: 'Người thứ tư đến thứ hai mươi: Chia sẻ 500,000 USDT + 17 sản phẩm xung quanh tuyệt vời',
    hjyq: 'Yêu cầu nhận giải',
    hjyq1: '1. Lợi nhuận từ cuộc thi hợp đồng = Giá trị cuối cùng của tài khoản (bao gồm lợi nhuận và lỗ chưa thực tế) - Giá trị ban đầu của tài khoản (bao gồm lợi nhuận và lỗ chưa thực tế) - Tiền tặng kèm hợp đồng tham gia cuộc thi.',
    hjyq2: '2. Trong trường hợp có nhiều người chơi có cùng lợi nhuận, người có giá trị giao dịch cao hơn sẽ thắng.',
    hjyq3: '3. Người chơi nhận giải cần đảm bảo lợi nhuận tài khoản lớn hơn 0.',
    // Quy tặc đóng góp
    gyc1: 'Hồ bơi giải thưởng chỉ dành cho người dùng khu vực cuộc thi hợp đồng và cuộc thi giao dịch hàng hóa, người dùng có thể kết thúc sớm cuộc thi và đóng góp số giao dịch / tỷ lệ lợi nhuận hiện tại vào hồ bơi từ thiện.',
    gyc2: 'Hệ thống sẽ đóng góp tiền thưởng từ thiện theo tỷ lệ 0.5 USDT cho mỗi phần trăm lợi nhuận, số dư của hồ bơi giải thưởng sẽ được công bố trên trang cuộc thi.',
    gyc3: 'Ví dụ: Người dùng A có tỷ lệ lợi nhuận thực tế là 38%, khi đó khi người dùng này đóng góp, hệ thống sẽ đóng góp 38 * 0.5 = 19 USDT vào hồ bơi từ thiện (tiền thưởng từ thiện là vàng giả lập).',
    gyc4: 'Số tiền tối đa tích lũy trong hồ bơi từ thiện: 50,000 USDT vàng giả lập',
    gyc5: 'Khi người dùng đóng góp số giao dịch, hệ thống sẽ đóng góp vào hồ bơi từ thiện theo tỷ lệ 0.5 USDT cho mỗi 100 USDT giao dịch, ví dụ: Nếu B người dùng có tổng giá trị giao dịch là 1000 USDT, đóng góp vào hồ bơi từ thiện là 0.5 USDT * 10 = 5 USDT (tiền thưởng từ thiện là vàng giả lập)',
    gyc6: 'Thời gian mở hồ bơi từ thiện: Trong vòng 7 ngày làm việc sau khi cuộc thi kết thúc, quay số ngẫu nhiên. (Mỗi người chỉ có một cơ hội trúng thưởng, không thể trùng lặp trong ba vòng)',
    gyc7: 'Lưu ý về đóng góp: Mỗi người dùng chỉ được tham gia một lần đóng góp từ thiện, sau khi đóng góp thành công, người dùng sẽ bị coi là từ chối quyền xếp hạng toàn bộ cuộc thi giao dịch biking, quyền nhận giải thưởng và quyền tham gia cuộc thi (người chơi trong khu vực cuộc thi giao dịch hợp đồng không thể tham gia cuộc thi giao dịch hàng hóa tiếp theo).',
    gyc8: 'Sau khi cuộc thi kết thúc, hồ bơi giải thưởng từ thiện sẽ mở ba vòng quay số, mỗi vòng sẽ chia đều giải thưởng cho 10 người, tỷ lệ phân phối giải thưởng của ba vòng là: 40%, 30%, 30%.',
    gyc9: 'Thời gian mở thưởng: Trong vòng 7 ngày làm việc sau khi cuộc thi kết thúc. Chi tiết vui lòng liên hệ với nhân viên chính thức.',
    xhjybs: 'Cuộc thi giao dịch hàng hóa',
    xhjybsgzsm: 'Giải thích quy tắc cuộc thi giao dịch hàng hóa',
    xhjydsphb: 'Bảng xếp hạng cuộc thi giao dịch hàng hóa',
    grbmcg: 'Đăng ký cá nhân thành công!',
    // 现货实大赛规则
    xhgz1: '1. Cuộc thi giao dịch hàng hóa chỉ bao gồm các cặp giao dịch cụ thể được xếp hạng trong năm đầu của sàn',
    xhgz2: '2. Người chơi tham gia cần đảm bảo số dư tài khoản hàng hóa lớn hơn 50 USDT',
    xhgz3: '3. Sau khi cuộc thi kết thúc, sàn sẽ xếp hạng tổng khu vực dựa trên tổng giá trị giao dịch hàng hóa của người chơi',
    jjfp: 'Phân phối giải thưởng',
    zjc: 'Tổng giải thưởng: 1,000,000 USDT + 20 sản phẩm xung quanh tuyệt vời',
    xhdym: 'Người đầu tiên: 400,000 USDT + 10 sản phẩm xung quanh tuyệt vời',
    xhdem: 'Người thứ hai: 200,000 USDT + 5 sản phẩm xung quanh tuyệt vời',
    xhdsm: 'Người thứ ba: 100,000 USDT + 5 sản phẩm xung quanh tuyệt vời',
    xhdsm1: 'Người thứ tư đến thứ hai mươi: Chia sẻ 300,000 USDT',
    mypdnpm: 'Bảng xếp hạng nội bộ cuộc thi giả lập',
    yqjl1: 'Thưởng mời',
    wdjye: 'Tổng giá trị giao dịch của tôi:',
    wdzsyl: 'Tỷ suất lợi nhuận tổng của tôi:',
    grzjyl: 'Tổng lượng giao dịch cá nhân giả lập:',
    grzsyl: 'Tỷ suất lợi nhuận tổng cá nhân giả lập:',
    sqzjye: 'Tổng giá trị giao dịch khu vực cuộc thi giả lập:',
    zjye: 'Tổng giá trị giao dịch khu vực:',
    bsyqrs: 'Số lượng người mời tham gia cuộc thi:',
    ren: 'người',
    hdmnj: 'Nhận vàng giả lập:',
    hdzj: 'Nhận tiền tặng kèm:',
    hyjyxq: 'Chi tiết cuộc thi giao dịch hợp đồng',
    xhjyxq: 'Chi tiết cuộc thi giao dịch hàng hóa',
    hy: 'Hợp đồng',
    xh: 'Giao dịch ngay',
    jlsm: 'Giải thưởng và giải thích',
    jlsm1: '1. Trong thời gian cuộc thi, người chơi (sau khi xác minh danh tính) có thể tự do mở đội, đội giao dịch hợp đồng cần đáp ứng số lượng thành viên ≥ 5 người; ≤200 người; nếu trong vòng 24 giờ sau khi mở đội không đạt đến 5 người, đội sẽ tự động giải tán.',
    jlsm2: '2. Mỗi người chỉ có thể tham gia một đội, không thể lặp lại, và không thể tự ý rời đội',
    tdjye: 'Lượng giao dịch của đội:',
    wdjs: 'Vai trò của tôi:',
    dz: 'Đội trưởng',
    dy: 'Đội viên',
    tdzyll: 'Tỷ suất lợi nhuận tổng của đội:',
    wdzyll: 'Tỷ suất lợi nhuận tổng của tôi:',
    tdyjhdjl: 'Ước tính thưởng của đội:',
    tdjs1: 'Giới thiệu đội:',
    grxq: 'Chi tiết cá nhân',
    tdxq: 'Chi tiết đội:',
    tdjylpm: 'Xếp hạng lượng giao dịch của đội:',
    tdzsyl: 'Tổng tỷ suất lợi nhuận của đội',
    tdnphb: 'Bảng xếp hạng nội bộ của đội',
    tcsybs: 'Ghi chú: Đóng góp hoàn tất là thoát khỏi tất cả các cuộc thi',
    zwcjhybs: 'Chưa tham gia cuộc thi giả lập hợp đồng',
    zwsj: 'Không có dữ liệu',
    tdmcbzq: 'Định dạng tên đội không đúng',
    tdjjbzq: 'Định dạng giới thiệu đội không đúng',
    hdjxz_contract: 'Khi cuộc thi giao dịch hợp đồng vĩnh viễn đang diễn ra sôi nổi, hãy tham gia cuộc thi để chia sẻ tổng giải thưởng 2.000.000U và giành được các thiết bị ngoại vi BiKing hào phóng',
    hdjxz_spot: 'Khi cuộc thi giao dịch giao ngay diễn ra sôi nổi, hãy tham gia cuộc thi để chia sẻ tổng giải thưởng 1.000.000U và giành được các thiết bị ngoại vi BiKing hào phóng',
    hdjs: 'Hãy chờ đón vòng thi tiếp theo nhé',
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/vi.js